import { b as getParamsFromForm } from "./utils-D8tYCXRD.js";
import { r as replacePersonalCansSection } from "./replacePersonalCansSection-BoLk9oIv.js";
const fallbackCartData = {
  attributes: {},
  cart_level_discount_applications: [],
  currency: "",
  item_count: 0,
  items: [],
  items_subtotal_price: "",
  note: null,
  original_total_price: 0,
  requires_shipping: false,
  token: null,
  total_discount: 0,
  total_price: 0,
  total_weight: 0
};
class Cart extends HTMLElement {
  static get observedAttributes() {
    return ["cart-data"];
  }
  constructor() {
    super();
    const initialCartData = this.getAttribute("cart-data");
    const parsedInitialCartData = initialCartData ? JSON.parse(initialCartData) : null;
    if (parsedInitialCartData && parsedInitialCartData.item_count) {
      this.cartData = parsedInitialCartData;
    } else {
      this.cartData = fallbackCartData;
    }
  }
  connectedCallback() {
    this.fetchCartData();
    const atcForms = document.querySelectorAll("form[data-productForm='true']");
    const cartData = JSON.parse(
      this.getAttribute("cart-data") || "{}"
    );
    atcForms.forEach((form) => {
      var _a;
      if ((_a = form.querySelector(".product-swatches__group")) == null ? void 0 : _a.classList.contains("product-swatches__single")) {
        form.addEventListener("submit", this.handleAtcSubmit.bind(this));
      } else {
        form.addEventListener(
          "submit",
          this.handleMultipleAtcSubmit.bind(this)
        );
      }
    });
    const quantityInputs = document.querySelectorAll(".product-swatches__quantity input");
    for (const input of quantityInputs) {
      const inputVariantId = input.dataset.id;
      const inputVariantInCart = cartData.items.find(
        (item) => item.id.toString() === inputVariantId
      );
      if (inputVariantInCart) {
        input.max = (parseInt(input.max) - inputVariantInCart.quantity).toString();
      }
    }
  }
  attributeChangedCallback(name, newValue) {
    if (name === "cart-data") {
      this._cartData = JSON.parse(newValue);
    }
  }
  get cartData() {
    return this._cartData;
  }
  set cartData(data) {
    this._cartData = data;
    this.updateAttribute(data);
  }
  getCartData() {
    return this._cartData;
  }
  updateAttribute(data) {
    this.setAttribute("cart-data", JSON.stringify(data));
  }
  updateOnCartChange() {
    this.setAttribute("cart-data", JSON.stringify(this.cartData));
  }
  async fetchCartData(fireEvent = false) {
    const cartDataResponse = await fetch(`${window.themeVars.routes.cart}.js`);
    this.cartData = await cartDataResponse.json();
    this.updateOnCartChange();
    if (!fireEvent) {
      return this.cartData;
    }
    document.dispatchEvent(
      new CustomEvent("cart:updated", { detail: this.cartData })
    );
    return this.cartData;
  }
  async handleMultipleAtcSubmit(event) {
    event.preventDefault();
    const cartItems = await this.fetchCart();
    const itemsToAdd = [];
    const variants = document.querySelectorAll(".product-swatches__form-group");
    variants.forEach((variant) => {
      var _a;
      const bundleProductData = variant.getAttribute("data-bundle-product");
      let bundleItem;
      if (bundleProductData && bundleProductData !== "null" && bundleProductData !== null) {
        bundleItem = JSON.parse(bundleProductData);
      }
      const quantityInput = variant.querySelector(
        ".product-swatches__quantity input"
      );
      const quantity = parseInt(quantityInput == null ? void 0 : quantityInput.value);
      let quantityToAdd = quantity;
      const bundleID = (_a = bundleItem == null ? void 0 : bundleItem.variants[0]) == null ? void 0 : _a.id;
      const quantityMax = (quantityInput == null ? void 0 : quantityInput.dataset.inventoryQuantity) ? parseInt(quantityInput == null ? void 0 : quantityInput.dataset.inventoryQuantity) : null;
      const variantId = quantityInput.dataset.id;
      const pfandValue = quantityInput == null ? void 0 : quantityInput.getAttribute("data-pfand");
      cartItems.items.forEach((item) => {
        if (variantId && item.id.toString() === variantId || item.properties["_variant_id"] === variantId) {
          if (quantityMax !== null && quantity > 0) {
            quantityToAdd = quantityMax - item.quantity;
          }
        }
      });
      const properties = pfandValue ? { Pfand: pfandValue } : {};
      if (bundleID) {
        properties["_variant_id"] = variantId || "";
        itemsToAdd.push({
          id: bundleID,
          quantity: quantityToAdd,
          properties,
          selling_plan: ""
        });
      } else {
        itemsToAdd.push({
          id: variantId,
          quantity: quantityToAdd,
          properties,
          selling_plan: ""
        });
      }
      quantityInput.value = "0";
      const newMaxQuantity = Number(quantityInput.max) - quantityToAdd;
      quantityInput.max = newMaxQuantity.toString();
    });
    if (itemsToAdd.length > 0) {
      this.addMultipleItems(itemsToAdd);
    }
    const hasQuantity = itemsToAdd.some((item) => item.quantity > 0);
    if (!hasQuantity) {
      this.displayNoQuantity();
    }
  }
  displayNoQuantity() {
    const productSwatches = document.querySelector("uwp-product-swatches");
    if (!productSwatches) {
      return;
    }
    productSwatches.classList.add("product-swatches--no-quantity");
    productSwatches.scrollIntoView({ behavior: "smooth" });
  }
  async handleAtcSubmit(event) {
    event.preventDefault();
    const form = event.target;
    const params = getParamsFromForm(form);
    if (!params.id) {
      return console.error("handleAtcSubmit: No variant ID found in form.");
    }
    const quantity = parseInt(params.quantity, 10) || 1;
    const selling_plan = params.selling_plan || "";
    const properties = Cart.extractProperties(params);
    this.addItem(params.id.toString(), quantity, properties, selling_plan);
  }
  static extractProperties(params) {
    const propertyInputKeys = Object.keys(params).filter(
      (key) => key.startsWith("properties")
    );
    const properties = {};
    propertyInputKeys.forEach((key) => {
      const propertyName = key.replace("properties[", "").replace("]", "");
      properties[propertyName] = params[key];
    });
    return properties;
  }
  addItem(id, quantity = 1, properties = {}, selling_plan = "") {
    if (!id) {
      return console.error("Cart.addItem() : id is required.");
    }
    const item = {
      id,
      quantity,
      properties,
      selling_plan
    };
    this.sendAddToCart([item]);
    return;
  }
  addMultipleItems(items) {
    if (!items || !items.length) {
      return console.error("Cart.addMultipleItems() : items are required.");
    }
    const hasQuantity = items.some((item) => item.quantity > 0);
    if (!hasQuantity) {
      return console.error(
        "Cart.addMultipleItems() : at least one item must have a quantity."
      );
    }
    this.sendAddToCart(items);
  }
  async fetchCart() {
    const response = await fetch("/cart.js");
    return await response.json();
  }
  async sendAddToCart(items) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let itemsWithPreOrder = items;
    if (((_b = (_a = window.ThemeVars) == null ? void 0 : _a.product) == null ? void 0 : _b.preOrder) === "true") {
      let formatDispatchDate = function(isoDate) {
        if (!isoDate)
          return "";
        const parts = isoDate.split("-").map((p) => parseInt(p, 10));
        if (parts.length !== 3)
          return isoDate;
        const [year, month, day] = parts;
        if (isNaN(year) || isNaN(month) || isNaN(day))
          return isoDate;
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ];
        const getOrdinal = (d) => {
          const v = d % 100;
          if (v >= 11 && v <= 13)
            return "th";
          switch (d % 10) {
            case 1:
              return "st";
            case 2:
              return "nd";
            case 3:
              return "rd";
            default:
              return "th";
          }
        };
        const monthName = monthNames[Math.max(0, Math.min(11, month - 1))];
        return `${day}${getOrdinal(day)} ${monthName} ${year}`;
      };
      const preOrderDateField = `${(_d = (_c = window.ThemeVars) == null ? void 0 : _c.product) == null ? void 0 : _d.preOrderDispatchEta}` ? `${(_f = (_e = window.ThemeVars) == null ? void 0 : _e.product) == null ? void 0 : _f.preOrderDispatchEta}` : "";
      const formattedPreOrderDispatchDate = typeof preOrderDateField === "string" ? formatDispatchDate(preOrderDateField) : "";
      const preOrderShipDate = window.themeVars.strings.cart.preOrderShipDate.replace(
        "{{ date }}",
        formattedPreOrderDispatchDate
      );
      itemsWithPreOrder = items.map((item) => ({
        ...item,
        properties: {
          ...item.properties || {},
          "_pre_order": "true",
          "Estimated Dispatch Date": preOrderShipDate
        }
      }));
    }
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items: itemsWithPreOrder })
    });
    const cart = await response.json();
    console.log(
      cart,
      "cart.sendAddToCart()",
      `${((_h = (_g = window.ThemeVars) == null ? void 0 : _g.product) == null ? void 0 : _h.preOrder) ?? ""}`
    );
    if (cart.error || cart.status) {
      console.error(
        `Cart.sendAddToCart() : ${cart.description || cart.message || "Unknown error"}`
      );
    } else {
      const updatedCartData = await this.fetchCartData();
      replacePersonalCansSection(updatedCartData);
      document.dispatchEvent(
        new CustomEvent("cart:added", { detail: updatedCartData })
      );
      document.dispatchEvent(
        new CustomEvent("cart:updated", { detail: updatedCartData })
      );
    }
  }
  addNote(note) {
    const updateBody = {
      note: "",
      // Clear the standard cart note
      attributes: {
        message: note
      }
    };
    this.sendCartUpdate(updateBody);
  }
  addAttribute(key, value) {
    const updateBody = { attributes: { [key]: value } };
    this.sendCartUpdate(updateBody);
  }
  addMultipleAttributes(attributes) {
    const updateBody = { attributes };
    this.sendCartUpdate(updateBody);
  }
  async sendCartUpdate(updateBody) {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(updateBody)
    });
    const cart = await response.json();
    if (cart.status) {
      console.error(
        `Cart.sendCartUpdate() : ${cart.description || cart.message || "Unknown error"}`
      );
    } else {
      this.cartData = cart;
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
      this.updateOnCartChange();
    }
  }
  changeItemQuantity(itemId, quantity) {
    const itemKey = parseInt(itemId.toString(), 10) < 1e3 ? "line" : "id";
    const changeBody = {
      [itemKey]: itemId.toString(),
      quantity
    };
    this.sendCartChange(changeBody);
  }
  changeItemProperties(itemId, properties) {
    if (!properties || Object.keys(properties).length === 0) {
      return console.error(
        "Cart.changeItemProperties() : properties are required and cannot be empty."
      );
    }
    const itemKey = typeof itemId === "string" || parseInt(itemId.toString(), 10) < 1e3 ? "line" : "id";
    const changeBody = {
      [itemKey]: itemId.toString(),
      properties
    };
    this.sendCartChange(changeBody);
  }
  async sendCartChange(changeBody) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(changeBody)
    });
    if (response.status && response.status !== 200) {
      console.error(
        `Cart.sendCartChange() : ${response.status === 404 ? "Item not in cart" : "Unknown error"}`
      );
    } else {
      const updatedCartData = await this.fetchCartData();
      replacePersonalCansSection(updatedCartData);
      document.dispatchEvent(
        new CustomEvent("cart:updated", { detail: updatedCartData })
      );
    }
  }
}
customElements.define("uwp-cart", Cart);
export {
  Cart as C
};
